<template>
    <div style="background:white; height:100%">
        <div style=" background:white;line-height:30px; border-bottom:2px solid #389;height:38px"> 
            <div style="padding-top:3px;display:flex;width:1400px;line-height:30px ">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;margin-right:15px;font-weight:600">新增 </span></el-link>
                </div>
 
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" style="width:150px;  " >
                    <span v-for="item in jobCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
 
            </div>
        </div>  
        <el-table  :data="jobData" 
              border                            
              size="small"
              class="custom-table-border"
              header-cell-class-name="clearPadding"
              v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
              ref="refjob"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="55" fixed align="center">
                  <template slot="header"  >
                    <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                        <el-tooltip content=" 清除条件" effect="light">
                            <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                        </el-tooltip>
                    </el-link>
                </template>
            </el-table-column>  
            <el-table-column  v-for="(item,index ) in jobCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :align="item.align"   :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-date-picker v-if="item.edcss=='date'" @change="stfgChange" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-select v-else-if="item.key=='STFG'" v-model="v_row[item.key]"  size="mini" @change="stfgChange" placeholder="请选择"  clearable style="width:100%">
                            <el-option label="否" value="N"></el-option>
                            <el-option label="是" value="Y"></el-option>
                        </el-select>  
                        <el-input type="number" @keyup.enter.native="stfgChange" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  placeholder="数字框" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'||item.key=='SEL'" v-else @keyup.enter.native="stfgChange"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template  slot-scope="scope" >
                        <el-tag  v-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">是</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">否</el-tag> 
                        <el-checkbox disabled v-else-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>                     
                        <span v-else  >{{scope.row[item.key]}}</span>
                    </template>
                </el-table-column>
            </el-table-column> 
             <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="170">
                <template slot-scope="scope">
                    <span v-if="scope.row['STFG']=='Y'" > 
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="editRec(scope.row,'Y',scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:11px;margin-right:5px">查看</span></el-link> 
                    </span>
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="editRec(scope.row,'N',scope.$index)" :underline="false" style="font-size:12px;margin-right:5px; "><span style="font-size:11px;margin-right:5px">编辑</span></el-link> 
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="stfgRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="stfgRec(scope.row,'X',scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:11px;">作废</span></el-link> 
                    </span>
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="jobRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in jobCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="jobRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="small" controls-position="right" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="jobRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select size="small"  :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="jobRow[item.key]"   style="width:100%">
                                <el-option v-for="(it,ind) in comboArr[item.key]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                            </el-select>
                            <el-input size="small" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="jobRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>          
                <div class="one-toolbar" style="margin-top:3px">
                    <span  class="spanRow"> 工序动作明细
                        <el-link  :underline="false" @click="subAdd" :disabled="saveFlag" style="border-bottom:1px solid white">
                            <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:white"></i><span style="font-size:12px;margin-right:5px;color:white;border-bottom:1px solid white"> 新增</span> 
                        </el-link>
                    </span>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    ref="refdtl"
                    style="margin-top:-8px"
                    :height="dtlHeight"
                    :row-key="getDtlKey"
                    highlight-current-row>  
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.edcss!=='checkbox'&&item.key!=='RN'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <div v-else-if="item.key=='IMGPATH'" style=" width:50px;height:42px; " >
                                <el-image   :preview-src-list="[scope.row.IMGPATH]"  fit="scale-down" style="width:50px;height:40px; "  :src="scope.row.IMGPATH">
                                    <div slot="error" ></div>
                                </el-image> 
                            </div>
                            <span v-else  >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="130">
                        <template slot-scope="scope">
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-edit" @click="subEdit(scope.row,scope.$index)">编辑</el-button>
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="subDel(scope.row,scope.$index)">删除</el-button>   
                        </template>
                    </el-table-column>                        
                </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i v-if="jobRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                    <i v-else-if="jobRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:30px;">  取消</el-button>
                    <el-button @click="saveRec" :disabled="addBool||saveFlag" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button > 
                </span>
            </div>
        </el-dialog>
        <!-- 明细资料框 -->
        <el-dialog v-dialogDrag  :visible.sync="subWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{subFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div>
            <Form :model="dtlRow" :label-width="120"  label-position="right" inline  >  
                <span v-for="(item,index) in dtlCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <template slot="label"><span style="color:red;margin-right:5px" v-if="item.key=='SUBNM'">*</span>{{item.title}}</template>
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="dtlRow[item.key]"  style="width:100%" ></el-input-number>    
                        <el-select :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="dtlRow[item.key]"   style="width:100%">
                            <el-option v-for="(it,ind) in comboArr[item.key]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                        </el-select>
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form> 
            <div class="one-toolbar" style="margin-top:3px">
                <span  class="spanRow">上传动作图片</span>
            </div>
            <div style="display:flex" >
                <Upload
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successFile"
                    :on-progress="handleProgress"
                    accept="jpg,jpeg,png,tif,tiff,gif,bmp"                           
                    :format="['jpg','jpeg','png','tif','tiff','gif','bmp' ]"
                    :max-size="10240"
                    :on-format-error="handleImgError"
                    :on-exceeded-size="handleMaxSize"
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">                           
                    <div style="padding: 1px 0;width:200px;height:150px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                       
                </Upload> 
                <div style="display:flex;margin-left:30px;"  >
                    <span v-if="V_IMGPATH" >
                    <el-image :preview-src-list="[V_IMGPATH]"  fit="fill"  style="width:200px;height:180px; " :src="V_IMGPATH"></el-image>
                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                        <el-link :disabled="saveFlag" :underline="false" @click="imgDel(V_IMGPATH)"><Icon type="md-close" /> 删除</el-link>
                    </div>  
                    </span>            
                </div> 
            </div>
            <span slot="footer"  >
                <el-button type="info" @click="subWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button @click="subSave" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
            </span>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 

export default {
    name:'standard_job',
    data () {
        return {
            V_IMGPATH :'',
            dtlRow:{},
            dtlCol:[],
            dtlData:[] ,
            promptWin:false,
            addFlag:'create',
           
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            v_row:{},
            jobRow:{},
            comboArr:[],
            goPage:'',
            rowIdseq:'',
            jobData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            loading:false,
            current:1,
            saveFlag:false,
            delArr:[],
            allList:[], //询价单集合
            subWin:false,
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            options: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            jobCol:[],
            operArr:[],
            oper:'like',
            v_idseq:this.$cookies.get('idseq'),
            v_rowIndex:'',
            notNull:[],
            stfgBool:true,
            uploadUrl:'xuper_auth/uploadImg' ,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            delPath:[],
            subFlag:'create',
            v_admin:this.$cookies.get('v_admin') , 
        }
    },
    components: {
 
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
        subHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 296) + 'px';
        }, 
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        this.comSelect()
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16521','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ // 
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16521','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getJobList('') //询价单主数据    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.stfgChange()
        } ,
        imgDel(path){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delPath.push(path)
                this.V_IMGPATH =''
                this.dtlData.splice(this.v_rowIndex,1,Object.assign(this.dtlRow,{IMGPATH:''}) )           
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        }, 
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出10M' 
        },
         //文件格式验证错误时的钩子
        handleImgError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 图片格式'
        },
        successFile(res,file){
            this.videoUploadPercent=0
            this.videoFlag = false
            let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.lastIndexOf('.'))
            this.V_IMGPATH =v_filename
            this.dtlData.splice(this.v_rowIndex,1,Object.assign(this.dtlRow,{IMGPATH:v_filename}) )                 
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {             
            this.fileName=this.v_username+ getDate('year')    
            this.uploadData = {
                code: this.fileName ,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise;  
        },
        subSave(){
            if (!this.dtlRow['SUBNM']){
                this.promptWin=true
                this.prompt='名称不能为空'
            }else{
                this.subWin =false
                if (this.subFlag==='edit' ){ //编辑时要替换数组记录
                    this.dtlData.splice(this.v_rowIndex,1,this.dtlRow)
                }else{
                    this.dtlData.push(this.dtlRow)
                }
            }
        },
        subAdd(){
            this.subWin =true
            this.dtlRow ={}
            this.subFlag ='create'
            this.v_rowIndex =''
        },
        subEdit(row ,index){
            this.dtlRow=JSON.parse(JSON.stringify(row))
            this.subWin=true
            this.v_rowIndex=index
            this.subFlag ='edit'
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            })
        } ,
        subDel(row,index){
            this.$confirm('你确定要删除此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                if (row['IMGPATH']){
                    this.delPath.push(row['IMGPATH'])
                }
                this.delArr.push(row)
                this.dtlData.splice(index,1)
            }).catch(err=>{})
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'16521',p_cond:' and lstseq in (1,4599)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                 this.saveFlag=false 
            }
            this.addFlag='edit'
            this.jobRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            this.delPath =[]
            this.delArr =[]
            this.V_IMGPATH =row['IMGPATH']
            this.addWin=true  
            this.getJobDtl(row.IDSEQ)    
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.jobRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {   
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.jobRow,{CORPID:this.v_corpid})), p_table:'bs_job',frmid:'16521'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        //明细保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'bs_jobdtl',p_idseq:res.idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                        //删除服务上的图片
                        this.delPath.forEach(item=>{
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/deleteFile',
                                data: {p_value: item},
                            })
                        })
                        //明细删除
                         if (this.delArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delArr), p_table:'bs_jobdtl',p_idseq:res.idseq,p_action:'D' },
                            })
                         }  
                        this.addWin =false   
                        this.stfgChange()
                    }else{  
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.jobRow={ 'IDSEQ':'','STFG':'N' }
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        //状态变更
        stfgRec(row,val,index){
            let v_comm='弃审'
            if (val=='X'){
                v_comm='作废'
            }if (val=='Y'){
                v_comm='审核'
            }
            if (val=='Y' && !row['WKNM']){
                this.promptWin =true
                this.prompt ='审核时工作中心不能为空'
                return
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_job',p_cond:' set stfg=\''+val+'\' '},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.jobData.splice(index,1)
                        } else{        
                            Object.assign(row,{STFGNM:v_comm ,STFG:val})
                        }
                    }    
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        stfgChange(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper=='!='){
                    cond_=cond_+' and  '+this.selparam+'  is null'  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            console.log(cond_,'...')
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.jobCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+' like \'%'+ (this.v_row[item]).trim()+'%\''
                    }
                }
            })     
            this.getJobList(cond_+v_cond)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.jobData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.jobData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.jobData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            
        },
 
        //工序清单 
        getJobList(cond){
            let vm =this
            getTabColOrData(this.v_url,'v_bs_job','','','CORPID',this.v_corpid,'','',cond+' order by '+this.selparam +' desc').then((res) => { 
                this.allList =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs['refjob'].doLayout()
                }) 
                this.initPage() 
            })
        },
        getJobDtl(idseq){
            getTabColOrData(this.v_url,'v_bs_jobdtl','idseq',idseq,'','','','', '').then((res) => { 
                this.dtlData =res.result 
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16521','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.jobCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16521','lstseq','4599','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        height:20px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
 <style lang ="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th{
            padding:0px;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
 </style>